import { Feature } from 'geojson'

function getBoundaryColumns(features: Feature[]): string[] {
  const regex = /MS_[a-zA-Z]{2}-[a-zA-Z]{3,50}/

  const boundaryColumns: Set<string> = new Set(['MS_zz-countries'])
  features.forEach((feature) => {
    if (feature.properties) {
      Object.keys(feature.properties).forEach((propertyName) => {
        if (regex.test(propertyName)) {
          boundaryColumns.add(propertyName)
        }
      })
    }
  })
  return [...boundaryColumns]
}

export { getBoundaryColumns }
